@if (!isLoadingFiles) {
	@if (viewType === 'edit') {
		<cpi-file-upload (getFiles)="handleFileAttachments($event)" [cleanFiles]="cleanAttachments" [labels]="labels"> </cpi-file-upload>

		<div class="button-container">
			<msp-button
				[disabled]="isUploadingFiles || (newCiAttachments && newCiAttachments.length === 0)"
				[loading]="isUploadingFiles"
				(click)="uploadFiles()">
				{{ labels.lbl_chat_enviar_arquivo }}
			</msp-button>
		</div>
	}

	@if (ciAttachments && ciAttachments.length > 0) {
		<span class="label">{{ labels.lbl_chat_arquivos_enviados }}</span>
		<div class="added-files-container">
			@for (file of ciAttachments; let index = $index; track file) {
				<div class="dotted-input-container file">
					<span>{{ file.name }}</span>
					<div class="button-container">
						@if (viewType === 'edit') {
							<span
								(click)="
									confirmDeleteFile.classList.contains('confirmClick')
										? deleteFile(index)
										: confirmButton(confirmDeleteFile)
								"
								#confirmDeleteFile>
								<fa-icon [icon]="icons.faTrash"></fa-icon>
							</span>
						}
						<span (click)="downloadFile(index)"><fa-icon [icon]="icons.faDownload"></fa-icon></span>
					</div>
				</div>
			}
		</div>
	} @else {
		<div>{{ labels.lbl_security_nenhum_registro }}</div>
	}
}

@if (isLoadingFiles) {
	<cpi-square-post-loading-effect [barThickness]="'8rem'"></cpi-square-post-loading-effect>
}
